if (!customElements.get('risuono-listen')) {
  customElements.define('risuono-listen', class extends HTMLElement {
    connectedCallback() {
      this.showVariant(this.dataset.selected);
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribeSelection = subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, () => this.showVariant(null));
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
          const productInfo = document.getElementById(`ProductInfo-${data.sectionId}`)?.closest('product-info');
          if (productInfo && String(productInfo.dataset.productId) !== this.dataset.product) return;
          this.showVariant(data.variant?.id);
        });
      }
    }
    showVariant(id) {
      let matched = false;
      this.querySelectorAll('[data-recording-variant]').forEach(panel => {
        panel.querySelectorAll('audio,video').forEach(media => media.pause());
        const show = String(panel.dataset.recordingVariant) === String(id);
        panel.hidden = !show;
        matched ||= show;
      });
      this.hidden = !matched;
      this.style.display = matched ? 'block' : 'none';
    }
    disconnectedCallback() { this.unsubscribe?.(); this.unsubscribeSelection?.(); }
  });
}

if (!customElements.get('risuono-reference-demo')) {
  customElements.define('risuono-reference-demo', class extends HTMLElement {
    connectedCallback() {
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, () => {
          this.querySelectorAll('audio,video').forEach(media => media.pause());
        });
      }
    }
    disconnectedCallback() { this.unsubscribe?.(); }
  });
}

// A single click on the listening control opens the demo and starts the media.
// If the browser blocks playback, the native controls remain available.
document.addEventListener('click', (event) => {
  const summary = event.target.closest('.risuono-listen__disclosure > summary');
  if (!summary) return;
  const disclosure = summary.parentElement;
  event.preventDefault();
  const shouldOpen = !disclosure.open;
  disclosure.open = shouldOpen;
  const selectedRecording = disclosure.querySelector('[data-recording-variant]:not([hidden])');
  const media = selectedRecording
    ? selectedRecording.querySelector('video, audio')
    : disclosure.querySelector('video, audio');
  if (!media) return;
  if (shouldOpen) {
    const playback = media.play();
    if (playback?.catch) playback.catch(() => {});
  } else {
    disclosure.querySelectorAll('audio, video').forEach((item) => item.pause());
  }
});
